import Collapse from './Collapse';
export default Collapse;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/collapse/index.js
// module id = 592
// module chunks = 0